<template>
    <div class="tbody flex wrap start vcenter">
        <template v-for="(entity, index) in entities" :key="index">
            <KeepAlive>
                <row class="flex start vcenter">
                    <Checkbox @onclick="() => {
                        if (selected.includes(entity[dynamic ? 'uid' : 'id']))
                            selected = selected.filter((item) => { return item !== entity[dynamic ? 'uid' : 'id'] })
                        else
                            selected.push(entity[dynamic ? 'uid' : 'id'])
                    }" :vm="selected.includes(entity[dynamic ? 'uid' : 'id'])"></Checkbox>
                    <div v-if="(Number(data.entity?.properties?.['PROCESS'] || '0') || 0) > 0 && data.entity?.properties?.['SITUATION'] !== 'NO'"
                        class="situation flex wrap center vcenter">
                        <p :style="{ backgroundColor: (situations[entity['0']]?.color || 'var(--gray)') }">{{
                            situations[entity['0']]?.name || '...' }}</p>
                        <span class="tooltip">{{ situations[entity['0']]?.name || 'درحال دریافت...' }}</span>
                    </div>
                    <template v-for="(meta, index) in data.metas" :key="index">
                        <div v-show="data.visibilities[meta.key] === 'visible'" class="column flex wrap center vcenter"
                            :class="[{ 'override': base.Entities().parse(meta.extras)['column'] }]" :style="{
                                'width': base.Entities().parse(meta.extras)['column']
                                    || (meta.style ? JSON.parse(meta.style)['width'] : '')
                            }" @click.prevent="oncopy(entity[translates['columns'][meta.key]])">
                            <p v-if="!['switch', 'rate'].includes(meta.type)">
                                {{
                                    (meta.type === 'date' || meta.type === 'datetime') &&
                                        !String(entity[translates['columns'][meta.key]])?.includes('/')
                                        ? base.Util().time({ unix: entity[translates['columns'][meta.key]], time: true }) || ''
                                        : meta.type === 'amount'
                                            ? String(entity[translates['columns'][meta.key]] || '0')?.replace(/\s/g,
                                                '').replace(/,/g,
                                                    '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                            : entity[translates['columns'][meta.key]]
                                }}</p>
                            <div v-else-if="meta.type === 'rate'" class="rate flex wrap center vcenter">
                                <img v-lazy="`/images/${rates[entity[translates['columns'][meta.key]] || 0]}.webp`"
                                    alt="rate" loading="lazy">
                            </div>
                            <i v-else class="fe fe-16"
                                :class="[{ 'fe-check': String(entity[translates['columns'][meta.key]]).toLowerCase() === 'true' || entity[translates['columns'][meta.key]] === true }
                                    , { 'fe-x': !(String(entity[translates['columns'][meta.key]]).toLowerCase() === 'true' || entity[translates['columns'][meta.key]] === true) }]"></i>
                            <span v-if="!['switch', 'rate'].includes(meta.type)" class="tooltip">
                                {{
                                    copied || ((meta.type === 'date' || meta.type === 'datetime') &&
                                        !String(entity[translates['columns'][meta.key]])?.includes('/')
                                        ? base.Util().time({ unix: entity[translates['columns'][meta.key]], time: true }) || ''
                                        : meta.type ===
                                            'amount'
                                            ? String(entity[translates['columns'][meta.key]])?.replace(/\s/g, '').replace(/,/g,
                                                '').num2persian() + ' ریال'
                                            : entity[translates['columns'][meta.key]])
                                }}</span>
                        </div>
                    </template>
                    <div v-if="data.visibilities['created_at']" class="created_at flex wrap center vcenter">
                        <p>{{ value = base.Util().time({
                            unix: entity[translates['columns']['created_at']], time: true
                        }) }}</p>
                        <span class="tooltip">{{ copied || value }}</span>
                    </div>
                    <div v-if="data.visibilities['status']" class="status flex wrap center vcenter">
                        <p :class="[
                            { 'active': [6, 100, 111, 200].includes(entity[translates['columns']['status']]) },
                            { 'pending': [1, 101, 102].includes(entity[translates['columns']['status']]) },
                            { 'inprocess': [113].includes(entity[translates['columns']['status']]) },
                            { 'failed': [103, 104, 105, 106, 201, 202, 203, -1, -2].includes(entity[translates['columns']['status']]) }
                        ]">{{ value = data.entity?.properties[entity[translates['columns']['status']]] ||
                            entity[translates['columns']['status']] }}</p>
                        <span class="tooltip">{{ copied || value }}</span>
                    </div>
                    <div v-if="data.visibilities['shield']" class="shield flex wrap center vcenter">
                        <i class="fe fe-16 fe-shield"></i>
                    </div>
                    <div v-show="data.visibilities['operations']" class="operations flex center vcenter">
                        <img v-if="data.visibilities['view'] && (![6, 104].includes(entity[translates['columns']['status']]) || user.grade === '1')"
                            v-lazy="'/images/eye.webp'" width="24" height="24" alt="view" loading="lazy"
                            @click.prevent="open(entity['0'])">
                        <img v-if="data.visibilities['delete'] && (![6, 104].includes(entity[translates['columns']['status']]) || user.grade === '1')"
                            v-lazy="'/images/delete.webp'" width="24" height="24" alt="delete" loading="lazy"
                            @click.prevent="del(entity['0'])">
                        <img v-if="data.visibilities['download'] && (![6, 104].includes(entity[translates['columns']['status']]) || user.grade === '1')"
                            v-lazy="'/images/download.webp'" width="24" height="24" alt="download" loading="lazy"
                            @click.prevent="$emit('ondownload', {
                                id: entity['0'],
                                fid: entity[translates['columns']['fid']],
                                uid: entity[translates['columns']['uid']],
                                amount: entity[translates['columns']['amount']],
                                referral_id: entity[translates['columns']['referral_id']]
                            })">
                        <img v-if="data.visibilities['document'] && (![6, 104].includes(entity[translates['columns']['status']]) || user.grade === '1')"
                            v-lazy="'/images/document.webp'" width="24" height="24" alt="document" loading="lazy"
                            @click.prevent="$emit('ondocument', {
                                id: entity['0'],
                                uid: translates[entity['0']]['uid'],
                                cid: entity[translates['columns']['cid']],
                                amount: entity[translates['columns']['amount']]
                            })">
                        <img v-if="data.visibilities['user'] && (![6, 104].includes(entity[translates['columns']['status']]) || user.grade === '1')
                            && translates[entity['0']]?.uid" v-lazy="'/images/account.webp'" width="24" height="24"
                            alt="user" loading="lazy" @click.prevent="inquiry(translates[entity['0']]?.uid)">
                        <img v-if="data.visibilities['maximize'] && (![6, 104].includes(entity[translates['columns']['status']]) || user.grade === '1') && !simplify"
                            v-lazy="'/images/maximize.webp'" width="24" height="24" alt="maximize" loading="lazy"
                            @click.prevent="overviews[entity['0']] = !overviews[entity['0']]">
                    </div>
                </row>
            </KeepAlive>
            <div v-if="overviews[entity['0']]" class="overview flex wrap"
                :class="[{ 'opened': overviews[entity['0']] }]">
                <div class="holder">
                    <Form :entity_type="entity_type" :entity_data="{
                        properties: {
                            allowed: extras?.allowed,
                            excludes: 'gift',
                            SUBFORM: true,
                        },
                        options: {}
                    }" :contents="parse(entity)"></Form>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable */
import Checkbox from '../Form/Inputs/Checkbox.vue'
import Form from '../Form.vue'

require('../../assets/js/amount')

export default {
    name: 'TBody',
    props: ['entity_type', 'page', 'size', 'data', 'contents', 'update', 'user'],
    inject: ['base'],
    components: { Checkbox, Form },
    computed: {
        query() {
            return this.data.entity?.properties?.query
        },
        order() {
            return this.data.order
        },
        direction() {
            return this.data.direction
        },
        simplify() {
            return this.data.simplify
        }
    },
    created() {
        this.init()
    },
    data() {
        return {
            dynamic: ['ACCOUNT', 'GROUP', 'ROLE', 'FOLDER', 'FILE', 'POST', 'CATEGORIZE', 'TAG']
                .includes(this.entity_type.toUpperCase()),
            entities: [],
            translates: [],
            situations: {},
            rates: {
                0: 'dead',
                1: 'angry',
                2: 'sad',
                3: 'suprise',
                4: 'smile',
                5: 'happy'
            },
            overviews: {},
            copied: '',
            count: 0,
            selected: []
        }
    },
    watch: {
        entity_type(newEntity, oldEntity) {
            this.init()
        },
        $route(newRoute, oldRoute) {
            if (newRoute.params.entity_type === oldRoute.params.entity_type)
                this.init()
        },
        query: {
            handler(newQuery, oldQuery) {
                if (newQuery)
                    Object.keys(newQuery).forEach((key) => {
                        if (oldQuery && oldQuery[key] !== newQuery[key]) {
                            this.init()
                            return
                        }
                    })
            },
            deep: true
        },
        data: {
            handler(newData, oldData) {
                if (this.data.all)
                    this.entities.forEach((entity) => {
                        if (!this.selected.includes(entity[this.dynamic ? 'uid' : 'id']))
                            this.selected.push(entity[this.dynamic ? 'uid' : 'id'])
                    })
                else
                    this.selected = this.data.selected || []
            },
            deep: true
        },
        order(newOrder, oldOrder) {
            this.init()
        },
        direction(newDirection, oldDirection) {
            this.init()
        },
        simplify(newSimplify, oldSimplify) {
            this.init()
        },
        contents: {
            handler(newContents, oldContents) {
                this.init()
            },
            deep: true
        },
        update(newUpdate, oldUpdate) {
            this.init()
        },
        count(newCount, oldCount) {
            this.$emit('onchange', {
                count: this.count,
                selected: this.selected,
                all: this.selected.length === Number(this.size)
            })
        },
        selected(newSelected, oldSelected) {
            this.$emit('onchange', {
                count: this.count,
                selected: this.selected,
                all: this.selected.length === Number(this.size)
            })
        }
    },
    methods: {
        init() {
            this.entities = []
            this.situations = {}
            this.count = 0
            this.selected = []

            if (this.contents) {
                this.load(this.contents['data'], this.contents['translates'], this.contents['data']?.length)
            } else {
                const route = this.$route.query

                if (!this.data.entity?.properties?.SUBLIST)
                    this.$emit('onloading', true)
                if (this.data.entity?.properties?.SEARCH && (this.$route.params.page || this.page) && (this.$route.params.size || this.size))
                    this.base.API().post(`${this.data.entity?.properties?.SEARCH}`,
                        {
                            entity_type: String(this.entity_type || this.$route.params.entity_type).toUpperCase(),
                            data: this.data.entity?.properties?.query || this.$route.query || {},
                            options: {
                                simplify: this.data?.simplify,
                                translate: true,
                                parameterized: true,
                                order: this.data?.order,
                                direction: this.data?.direction,
                                page: this.$route.params.page || this.page,
                                size: this.$route.params.size || this.size
                            }
                        }, (response) => {
                            if (this.base.Util().success(response)
                                && this.base.Util().validate(response.data.data)) {
                                if (route !== this.$route.query)
                                    return
                                this.load(response.data.data, response.data.translates, response.data.count)
                            }
                            this.$emit('onloading', false)
                        }, (error) => {
                            this.$emit('onloading', false)
                        })
                else
                    this.$emit('onloading', false)
            }
        },
        load(data, translates, count) {
            this.entities = data
            this.translates = translates

            this.count = Number(count)

            let pid = Number(this.data?.entity?.properties?.['PROCESS'] || '0') || 0
            if (pid > 0 && Array.isArray(this.entities)) {
                const uids = this.entities.map(entity => `${entity['0']}`)
                if (uids && uids.length > 0)
                    this.base.API().post(`Procedures/Situation/Review?pid=${pid}&entity_type=${this.data.entity?.properties?.SITUATION_TYPE || this.entity_type || this.$route.params.entity_type}`,
                        {
                            data: uids
                        }, (response) => {
                            if (this.base.Util().success(response))
                                this.situations = response.data.data
                        }, (error) => {
                        })
            }
        },
        open(id) {
            let path = `/Dashboard/Form/${this.data.entity?.properties?.VIEW_TYPE || this.entity_type}`
            window.open(this.base.Util().validate(id) ? path + `/${id}` : path)
        },
        inquiry(uid) {
            window.open(`/Dashboard/Inquiry/Internal?value=${uid}`)
        },
        del(id) {
            this.$confirm(
                {
                    message: `آیا از حذف ${this.data?.entity.title || 'ردیف'} اطمینان دارید؟`,
                    button: {
                        no: 'خیر',
                        yes: 'بله'
                    },
                    callback: async confirm => {
                        if (confirm) {
                            if (this.data.entity?.properties?.DEL)
                                this.base.API().del(`${this.data.entity?.properties?.DEL}`, { data: { id: id } }, (response) => {
                                    if (this.base.Util().success(response)) {
                                        this.init()
                                        this.$router.push({ path: window.location.pathname.replaceAll(`/${this.$route.params.page}/${this.$route.params.size}`, '/1/15'), params: { entity_type: this.data.entity_type, page: 1, size: 15 } })
                                    } else
                                        this.base.Notification().error({
                                            code: response.data.errorCode,
                                            referr: this.entity_type
                                        })
                                }, (error) => {
                                })
                        }
                    }
                }
            )
        },
        parse(entity) {
            let parsed = {}
            let columns = this.translates['columns']
            let keys = Object.keys(columns)
            for (const key of Object.keys(entity)) {
                let _key = keys.find(_key => columns[_key] === key)
                parsed[_key] = this.translates[entity['0']]?.[_key] || entity[this.translates['columns'][_key]]

            }
            return parsed
        },
        oncopy(value) {
            navigator.clipboard.writeText(value)
            this.copied = 'کپی شد!'
            setTimeout(() => this.copied = '', 500)
        },
    }
}
</script>